import React from "react";
import Modal from "@mui/material/Modal";

import Button from "../../Components/Button/Button";

// Every publish action asks first (Devin 2026-10-22): a recall list or
// results going on (or off) the public page, and the family-results switch.
// kind: "recall" | "results" | "families" | "names"; on: true = publish / show.
// "names" is the Draw screen's running-orders switch (card f6c2c874).
export function publishAsk(kind, code, on) {
  if (kind === "names") {
    return on
      ? {
          title: "Show the running orders to families and teachers?",
          body: "Every locked draw's running order shows on feis.link and in the app straight away, names only. Competitor numbers still come out at 7:00 am on each competition's day.",
          label: "Show running orders",
        }
      : {
          title: "Hide the running orders from families and teachers?",
          body: "They stop seeing the names-only running orders straight away. Each competition's numbered running order still comes out at 7:00 am on its day.",
          label: "Hide running orders",
        };
  }
  if (kind === "families") {
    return on
      ? {
          title: "Show results to families?",
          body: "Families see their dancers' published results on their accounts straight away.",
          label: "Show to families",
        }
      : {
          title: "Hide results from families?",
          body: "Families stop seeing their dancers' results on their accounts. Published competitions stay on the public results page.",
          label: "Hide from families",
        };
  }
  if (kind === "recall") {
    return on
      ? {
          title: `Publish the recall list for ${code}?`,
          body: "It goes on the public results page straight away, and round 3 check-in opens for the recalled dancers.",
          label: "Publish recall",
        }
      : {
          title: `Take the ${code} recall list off the public page?`,
          body: "Families stop seeing it straight away. Round 3 check-in closes until it is published again.",
          label: "Unpublish recall",
        };
  }
  return on
    ? {
        title: `Publish the results for ${code}?`,
        body: "Families see them on the public results page straight away. Publish once the results have been announced.",
        label: "Publish results",
      }
    : {
        title: `Take the ${code} results off the public page?`,
        body: "Families stop seeing them straight away.",
        label: "Unpublish results",
      };
}

// ask: { title, body, label } or null; onConfirm / onCancel. Also used for
// other confirmations on these screens (clearing a judge's sheet).
const PublishConfirm = ({ ask, onConfirm, onCancel }) => (
  <Modal open={!!ask} onClose={onCancel}>
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
        background: "#FFFFFF", borderRadius: "8px", padding: "24px",
        width: "min(440px, 92vw)", outline: "none",
      }}
    >
      <b>{ask?.title}</b>
      <div className="grey-42 mt-2" style={{ fontSize: "13px" }}>{ask?.body}</div>
      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button className="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button className="filled" onClick={onConfirm}>
          {ask?.label}
        </Button>
      </div>
    </div>
  </Modal>
);

export default PublishConfirm;
